import * as core from '../../../../../../../core'
import * as rpBch from '../rp-bch'

export const RESOURCE = {
  payload: {
    alias: 'overview',
    appAlias: rpBch.RESOURCE.payload.alias,
    description: 'A good place to get started',
    display: {
      isMain: true,
      position: 0,
    },
    name: 'Overview',
    page: { alias: 'rp:overview' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
